module.exports = __webpack_public_path__ + "static/dracalien-a02a37aa6dee173159fd89e6ed0dcdd4.jpg";